import type {
  AssetsAsset,
  DepositWithdrawAssets,
  DepositWithdrawFiatType,
  DictionaryResponse,
} from '@/shared/types';
import type { AccontTypeData, RegularAccount } from '@/entities/account';
import type { FiatWithdrawAssetOption } from '@/entities/operation';

interface GetFiatWithdrawAssetOptionsParams {
  key: DepositWithdrawFiatType;
  assetsData: DictionaryResponse<AssetsAsset[]> | undefined;
  assetsIconsData: DictionaryResponse<Record<string, string>> | undefined;
  depositWithdrawAssetsData: { value: DepositWithdrawAssets } | undefined;
  mainAccount: RegularAccount | undefined;
  ewallet: AccontTypeData<RegularAccount> | null;
}

export function getFiatWithdrawAssetOptions({
  key,
  assetsData,
  assetsIconsData,
  depositWithdrawAssetsData,
  mainAccount,
  ewallet,
}: GetFiatWithdrawAssetOptionsParams): FiatWithdrawAssetOption[] {
  if (!assetsData || !assetsIconsData || !ewallet?.accounts) {
    return [];
  }

  if (!mainAccount) {
    return [];
  }

  const withdrawAssets = depositWithdrawAssetsData?.value?.withdraw?.fiat || [];
  const data = withdrawAssets.find(item => Object.keys(item)[0] === key);

  if (!data) {
    return [];
  }

  const currencies = data[key as keyof DepositWithdrawFiatType] || [];
  const assetsDataMap = new Map<string, AssetsAsset>();

  (assetsData?.value || []).forEach(asset => {
    assetsDataMap.set(asset.code, asset);
  });

  return currencies.map(currency => {
    const mainAccountAsset = mainAccount.assets.find(
      asset => asset.code === currency.code
    );

    return {
      code: currency.code,
      min: currency.min,
      max: currency.max,
      name: assetsDataMap.get(currency.code)?.name || '',
      icon: assetsIconsData.value?.[currency.code] || '',
      available: mainAccountAsset?.available || 0,
    };
  });
}
